/**
 * 生成随机UUID
 * @returns {string} 返回UUID字符串
 */
export function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

/**
 * 生成指定长度的随机字符串
 * @param {number} length 字符串长度，默认32位
 * @returns {string} 返回随机字符串
 */
export function generateRandomString(length = 32) {
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    for (let i = length; i > 0; --i) {
        result += chars[Math.floor(Math.random() * chars.length)];
    }
    return result;
}

/**
 * 生成带时间戳的UUID
 * @returns {string} 返回带时间戳的UUID
 */
export function generateTimeBasedUUID() {
    const timestamp = new Date().getTime().toString(16);
    const randomPart = generateRandomString(16);
    return `${timestamp}-${randomPart}`;
} 